module.exports = __webpack_public_path__ + "static/media/undraw_transfer_money_rywa 1.db1c3f86.svg";